import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var TaskService = /** @class */ (function (_super) {
    tslib_1.__extends(TaskService, _super);
    function TaskService(http) {
        var _this = _super.call(this, http, MapperService.taskMapper) || this;
        _this._endpoint = '/odata/Tasks';
        return _this;
    }
    TaskService.prototype.assignToUser = function (tasks, userId) {
        var _this = this;
        var url = this._endpoint + "/UiPath.Server.Configuration.OData.AssignTasks";
        return this._http.post(url, this._createTaskAssignmentPayload(tasks, userId))
            .pipe(map(function (res) { return _this._mapData(res, MapperService.taskAssignmentResponseMap); }));
    };
    TaskService.prototype.reAssignToUser = function (tasks, userId) {
        var _this = this;
        var url = this._endpoint + "/UiPath.Server.Configuration.OData.ReassignTasks";
        return this._http.post(url, this._createTaskAssignmentPayload(tasks, userId))
            .pipe(map(function (res) { return _this._mapData(res, MapperService.taskAssignmentResponseMap); }));
    };
    TaskService.prototype.unAssignFromUser = function (tasks) {
        var _this = this;
        var url = this._endpoint + "/UiPath.Server.Configuration.OData.UnassignTasks";
        return this._http.post(url, this._createTaskUnassignmentPayload(tasks))
            .pipe(map(function (res) { return _this._mapData(res, MapperService.taskAssignmentResponseMap); }));
    };
    TaskService.prototype.suggestTaskUsers = function (organizationUnitId, searchTerm, fetchSize, skip) {
        var _this = this;
        if (searchTerm === void 0) { searchTerm = ''; }
        if (fetchSize === void 0) { fetchSize = 20; }
        if (skip === void 0) { skip = 0; }
        var queryOptions = {
            select: ['UserName', 'Id'],
            orderBy: ['UserName'],
            top: fetchSize,
            skip: skip,
            filter: {
                UserName: {
                    startswith: searchTerm,
                },
            },
        };
        var endpoint = this._endpoint + "/UiPath.Server.Configuration.OData.GetTaskUsers(organizationUnitId=" + organizationUnitId + ")";
        return this._http
            .get("" + endpoint + this.getQueryString(queryOptions))
            .pipe(map(function (response) { return _this._mapData(response, MapperService.userLoginInfoMap); }), map(function (_a) {
            var data = _a.data, total = _a.total;
            return ({
                total: total,
                data: data.map(function (user) { return ({
                    id: user.id,
                    text: user.userName,
                }); }),
            });
        }));
    };
    TaskService.prototype._createTaskAssignmentPayload = function (tasks, userId) {
        var _this = this;
        var taskAssignments = tasks.map(function (task) { return _this._toPoco({
            userId: userId,
            taskId: task.id,
        }, MapperService.taskAssignmentRequestMap); });
        return JSON.stringify({ taskAssignments: taskAssignments });
    };
    TaskService.prototype._createTaskUnassignmentPayload = function (tasks) {
        var taskIds = tasks.map(function (task) { return task.id; });
        return JSON.stringify({ taskIds: taskIds });
    };
    return TaskService;
}(ODataService));
export { TaskService };
